import React from 'react';

export function ReservationForm({ children, onSubmit, sectionTitle, actions }) {
  return (
    <form className="call-form-shell" onSubmit={onSubmit}>
      <div className="call-form-section">
        {sectionTitle ? <div className="call-form-section-title">{sectionTitle}</div> : null}
        <div className="call-form-grid">
          {children}
        </div>
      </div>
      {actions ? <div className="kanban-actions" style={{ justifyContent: 'flex-end' }}>{actions}</div> : null}
    </form>
  );
}
